import { crudController } from 'fc-controller'

import {
  URL,
  MODEL,
} from 'fc-model-assets'

import {
  TREE,
  BRANCH,
} from 'fc-assets'

// Selectors
import token$ from 'fc-auth/src/selectors/token'

// Initialze
import initialize from './initialize'

// Controller
export default crudController({
  url: URL,
  model: MODEL,
  tree: TREE,
  branch: BRANCH,
  token$,
  initialize,
})
